import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useDispatch, useSelector } from "react-redux";
// import performRequest from "../../../Kryzen Alpha App/api/request";
// import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import NhmAppTable from "./nhm_applicants_table";
// import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcVoicePresentation } from "react-icons/fc";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import performRequest from "../../../api/request";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";
import { MdStar } from "react-icons/md";
import {
  setCurrentPage,
  setReduxFilters,
} from "../../../redux/Pagination/nhmApplicants";
import Pagination from "../../../Components/layouts/pagination";

const NHMApplicants = () => {
  const dispatch = useDispatch();
  const store = useSelector((store) => store?.nhmFilters);
  const [refresh, setRefresh] = useState(false);

  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(store.filters);
  const [page, setCurrPage] = useState(store.currentPage);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [stateData, setStateData] = useState();
  useEffect(() => {
    performRequest("GET", "/nhm-applicants/getfilterLists/")
      .then((res) => {
        if (res.status === 200) {
          setStateData(res.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(
        "/nhm-applicants/getNHMApplicants/",
        store?.currentPage,
        store?.filters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.NHMApplicantsCount / 50));
        } else {
          Toast("error", "Error while getting NHMApplicants!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, store.currentPage]);

  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);
  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              {/* <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcMms className="fs-2 me-1" />
                    Agri Subsidy
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div> */}

              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcVoicePresentation className="fs-2  me-1" />
                    NHM Applicants
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                {/* <div className="col-md-4 d-none d-sm-block">
                  <div className="btn-list justify-content-end">
                    <a href={"/agri-subsidy/"}>
                      <button className="btn btn-primary text-uppercase">
                        <BsPassFill />
                        &nbsp; Apply for subsidy
                      </button>
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        startdate: e.target.value,
                                      })
                                    );
                                  }}
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        enddate: e.target.value,
                                      })
                                    );
                                  }}
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search Contact No:"
                                  value={filters.Mobile}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      Mobile: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        Mobile: e.target.value,
                                      })
                                    );
                                  }}
                                  placeholder="Search Contact No..."
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search Name:"
                                  value={filters.Name}
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      Name: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        Name: e.target.value,
                                      })
                                    );
                                  }}
                                  placeholder="search name..."
                                />
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select District:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      District: e.target.value,
                                    });

                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        District: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.District}
                                >
                                  <option value="">select all</option>
                                  {stateData?.District?.map((data, index) => (
                                    <option value={data?.District}>
                                      {data?.District}
                                    </option>
                                  ))}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Status:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      seenStatus: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        seenStatus: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.seenStatus}
                                >
                                  <option value="">select all</option>
                                  <option value="reachedToAlpha">
                                    Reached To Alpha
                                  </option>
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Taluka:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      Taluka: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        Taluka: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.Taluka}
                                >
                                  <option value="">select all</option>
                                  {stateData?.Taluka?.map((data, index) => (
                                    <option value={data?.Taluka}>
                                      {data?.Taluka}
                                    </option>
                                  ))}
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Village:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      Village: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        Village: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.Village}
                                >
                                  <option value="">select all</option>
                                  {stateData?.Village?.map((data, index) => (
                                    <option value={data?.Village}>
                                      {data?.Village}
                                    </option>
                                  ))}
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Structure:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      Structure: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        Structure: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.Structure}
                                >
                                  <option value="">select all</option>
                                  {stateData?.Structure?.map((data, index) => (
                                    <option value={data?.Structure}>
                                      {data?.Structure}
                                    </option>
                                  ))}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select System:"
                                  onChange={(e) => {
                                    setFilters({
                                      ...filters,
                                      System: e.target.value,
                                    });
                                    dispatch(
                                      setReduxFilters({
                                        ...filters,
                                        System: e.target.value,
                                      })
                                    );
                                  }}
                                  value={filters.System}
                                >
                                  <option value="">select all</option>
                                  {stateData?.System?.map((data, index) => (
                                    <option value={data?.System}>
                                      {data?.System}
                                    </option>
                                  ))}
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        dispatch(setCurrentPage(1));
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        dispatch(
                                          setReduxFilters({
                                            startdate: "",
                                            enddate: "",
                                            Name: "",
                                            Mobile: "",
                                            District: "",
                                            Taluka: "",
                                            Village: "",
                                            Structure: "",
                                            System: "",
                                            seenStatus: "",
                                          })
                                        );
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          Name: "",
                                          Mobile: "",
                                          District: "",
                                          Taluka: "",
                                          Village: "",
                                          Structure: "",
                                          System: "",
                                          seenStatus: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  );
                                }}
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  );
                                }}
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search Contact No:"
                                value={filters.Mobile}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    Mobile: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      Mobile: e.target.value,
                                    })
                                  );
                                }}
                                placeholder="Search Contact No..."
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search Name:"
                                value={filters.Name}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    Name: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      Name: e.target.value,
                                    })
                                  );
                                }}
                                placeholder="search name..."
                              />
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select District:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    District: e.target.value,
                                  });

                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      District: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.District}
                              >
                                <option value="">select all</option>
                                {stateData?.District?.map((data, index) => (
                                  <option value={data?.District}>
                                    {data?.District}
                                  </option>
                                ))}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Status:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    seenStatus: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      seenStatus: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.seenStatus}
                              >
                                <option value="">select all</option>
                                <option value="reachedToAlpha">
                                  Reached To Alpha
                                </option>
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Taluka:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    Taluka: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      Taluka: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.Taluka}
                              >
                                <option value="">select all</option>
                                {stateData?.Taluka?.map((data, index) => (
                                  <option value={data?.Taluka}>
                                    {data?.Taluka}
                                  </option>
                                ))}
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Village:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    Village: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      Village: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.Village}
                              >
                                <option value="">select all</option>
                                {stateData?.Village?.map((data, index) => (
                                  <option value={data?.Village}>
                                    {data?.Village}
                                  </option>
                                ))}
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Structure:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    Structure: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      Structure: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.Structure}
                              >
                                <option value="">select all</option>
                                {stateData?.Structure?.map((data, index) => (
                                  <option value={data?.Structure}>
                                    {data?.Structure}
                                  </option>
                                ))}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select System:"
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    System: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      System: e.target.value,
                                    })
                                  );
                                }}
                                value={filters.System}
                              >
                                <option value="">select all</option>
                                {stateData?.System?.map((data, index) => (
                                  <option value={data?.System}>
                                    {data?.System}
                                  </option>
                                ))}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      dispatch(setCurrentPage(1));
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      dispatch(
                                        setReduxFilters({
                                          startdate: "",
                                          enddate: "",
                                          Name: "",
                                          Mobile: "",
                                          District: "",
                                          Taluka: "",
                                          Village: "",
                                          Structure: "",
                                          System: "",
                                          seenStatus: "",
                                        })
                                      );
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        Name: "",
                                        Mobile: "",
                                        District: "",
                                        Taluka: "",
                                        Village: "",
                                        Structure: "",
                                        System: "",
                                        seenStatus: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card mt-3 p-2">
                    <ul>
                      <li className="mt-2">
                        Lead created : <MdStar style={{ color: "green" }} />
                      </li>
                      <li className="mt-2">
                        Client reached to Alpha :{" "}
                        <div
                          className="avatar avatar-xs bg-success-lt"
                          data-demo-color=""
                        ></div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <NhmAppTable
                      data={data?.NHMApplicantsData}
                      currentPage={page}
                      itemsPerPage={50}
                    />
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.NHMApplicantsData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default NHMApplicants;
